<template>
  <PanelItem :index="index" :field="field">
    <template #value>
      <FormValueListTable
        v-if="theData.length > 0"
        :edit-mode="false"
        class="overflow-hidden"
      >
        <FormValueListHeader
          :value-label="field.valueLabel"
        />

        <div
          class="bg-gray-50 dark:bg-gray-700 overflow-hidden key-value-items"
        >
          <FormValueListItem
            v-for="(item, index) in theData"
            :index="index"
            :item="item"
            :disabled="true"
          />
        </div>
      </FormValueListTable>
    </template>
  </PanelItem>
</template>

<script>
import map from 'lodash/map'

export default {
  props: ['index', 'resource', 'resourceName', 'resourceId', 'field'],

  data: () => ({ theData: [] }),

  created() {
      this.theData = map(this.value || [], (value) => ({
          value,
      }))
  },
}
</script>
